import React, { useState } from "react";
import { Container, Collapse } from "reactstrap";
import "./FAQ.css";

const faqs = [
  {
    q: "What is included in the price?",
    a: "Dedicated instances include the hardware specs listed (CPU, GPU, storage, network). Cloud and runtime plans include managed infrastructure and 97% uptime target. All plans include access to support.",
  },
  {
    q: "How quickly can I get deployed?",
    a: "We aim to deploy within 1–3 business days. Some setups need your input (e.g. remote access). If we don’t hear back within 3 days, deployment may be delayed—see our Terms of Use and Refund Policy.",
  },
  {
    q: "What is your refund policy?",
    a: "You may request a refund within 3 days of a new purchase if the service has not yet been deployed. Once deployed, purchases are non-refundable. Renewals and subscriptions are non-refundable. See our Refund Policy for full details.",
  },
  {
    q: "How do I get support?",
    a: "Email us at support@hostingnoodle.com. We aim to respond within 24 hours. Our registered office is in London, UK—see the Contact page for the full address.",
  },
  {
    q: "What uptime do you guarantee?",
    a: "We target 97% uptime. Service availability can be affected by maintenance, infrastructure issues, or third-party providers—see our Terms of Use.",
  },
  {
    q: "Can I use Noodle DevOp with Cloud or Dedicated?",
    a: "Yes. Noodle DevOp (Standard and Pro) is compatible with both Noodle Cloud Processing and Noodle Dedicated Instances, so you can get custom deployment and runtime solutions for your chosen environment.",
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState(null);
  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <section className="hn-faq">
      <Container>
        <h2 className="hn-faq-title">Frequently asked questions</h2>
        <p className="hn-faq-subtitle text-muted">Quick answers to common questions.</p>
        <div className="hn-faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className="hn-faq-item">
              <button
                type="button"
                className="hn-faq-q"
                onClick={() => toggle(i)}
                aria-expanded={openId === i}
                aria-controls={`faq-a-${i}`}
                id={`faq-q-${i}`}
              >
                <span>{faq.q}</span>
                <i className={`fas fa-chevron-${openId === i ? "up" : "down"}`} aria-hidden="true" />
              </button>
              <Collapse isOpen={openId === i}>
                <div id={`faq-a-${i}`} className="hn-faq-a" role="region" aria-labelledby={`faq-q-${i}`}>
                  {faq.a}
                </div>
              </Collapse>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FAQ;
